// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown_wrapper[data-v-451127d5]{height:auto;overflow:hidden;display:block;max-height:0;transition:max-height .4s ease-in-out}", ""]);
// Exports
module.exports = exports;
